export default "__VITE_ASSET__8dd1bb9f__"